<template>
    <div class="as-product_advanced_selector">
        <mock-el-select
			slot="reference"
			size="small"
            :focus="dialogVisible"
            :multiple="multiple"
			:tag-list="selectViewData"
            :placeholder="placeholder"
            :collapseTags="true"
            :clearable="true"
			:props="{label: 'name', id: 'no'}"
			@close="handleTagClose"
            @clear="handleTagClear"
			@click.native="onShowDialog"
            :wordNumber="18">
		</mock-el-select>
        <as-product-dialog-selector
            ref="dialogSelector"
            v-on="$listeners"
            v-bind="$attrs"
            v-model="dialogVisible"
            :selectId="checkedKeys[0]"
            :multiple="multiple"
            :loading="dialogLoading"
            :group-data="selectorData"
            :sidebar-list="sidebarData"
            :default-checked-keys="checkedKeys"
            @on-confirm="onConfirm"
            @on-select-item="onSelectItem">
        </as-product-dialog-selector>
    </div>
</template>

<script>
    import MockElSelect from '@/components/mock-el-select'
    import AsProductDialogSelector from '@/components/product-dialog-selector'
    import AdvancedSelector from '@/components/advanced-selector'
    export default {
        extends: AdvancedSelector,
        name: 'AsProductAdvancedSelector',
        components: {
            MockElSelect,
            AsProductDialogSelector,
        },
        props: {
            multiple: Boolean,
            filterMethod: Function,
            defaultSelectView: {
                type: String,
                default: '',
            }
        },
        computed: {
            checkedKeys() {
                const idList = this.defaultCheckedKeys.length ? this.defaultCheckedKeys : (this.selectListData ? this.selectListData.map(item => item.no) : []);
                return  idList;
            },
            selectViewData() {
                return this.selectListData || this.defaultSelectViewData;
            },
        },
        methods: {
            handleTagClear() {
                this.selectListData = [];
                this.triggerEvent(this.selectListData);
            },
            handleTagClose(index) {
                this.selectListData.splice(index, 1);
                this.triggerEvent(this.selectListData);
            },
            loadDataCallback(productList) {
                const categoryGroupData = {};
                const categoryMapData = {};
                const categoryList = [];
                for(let i =0 ;i< productList.length;i++){
                    const itemData = productList[i];
                    const valid = this.filterMethod ? this.filterMethod(itemData) : true;
                    if (!valid) continue;
                    const categoryKey = itemData.marqueid;
                    if (!categoryList.includes(categoryList)) {
                        categoryList.push(categoryKey);
                    }
                    itemData.price = itemData.saleprice;
                    if (!categoryGroupData[categoryKey]) {
                        categoryGroupData[categoryKey] = [];
                        categoryMapData[categoryKey] = {
                            no: categoryKey,
                            name: itemData.marquetype,
                            marqueid: categoryKey,
                        }
                    }
                    categoryGroupData[categoryKey].push(itemData);
                }
                const listData = [];
                const sidebarListData = [{
                    no: -1,
                    name: '全部',
                    marqueid: -1,
                }];
                for(let categoryId in categoryGroupData) {
                    const categoryData = categoryMapData[categoryId];
                    const categoryChildrenData = categoryGroupData[categoryId];
                    categoryData.children = categoryChildrenData;
                    if (categoryChildrenData && categoryChildrenData.length) {
                        listData.push(categoryData);
                        sidebarListData.push(categoryData);
                    }
                }
                this.dialogLoading = false;
                this.loadSelectorData = listData.sort((prevItem, nextItem) => {
                    const prevIndex = categoryList.indexOf(prevItem.marqueid);
                    const nextIndex = categoryList.indexOf(nextItem.marqueid);
                    return prevIndex - nextIndex;
                });
                this.loadSidebarData = sidebarListData.sort((prevItem, nextItem) => {
                    const prevIndex = categoryList.indexOf(prevItem.marqueid);
                    const nextIndex = categoryList.indexOf(nextItem.marqueid);
                    return prevIndex - nextIndex;
                });
            },
        }
    }
</script>
<style lang="scss">
.as-product_advanced_selector {
    display: inline-flex;
}
</style>